export const NAME = 'billing';
export const PAYMENT_TYPE = 'payment_type';
export const UNPAID = 'unpaid';
export const PAID = 'paid';
export const PENDING = 'pending';
